import { uiLocale } from '../i18n';
import { proseComponents } from './markdown/MarkdownProse';

// Shared by the global and expert report archives: calendar dates stay
// calendar dates (DB DATE), timestamps are shown in Europe/Paris.
export const reportDate = value => {
  const date = new Date(`${String(value || '').slice(0, 10)}T00:00:00Z`);
  return Number.isNaN(date.getTime()) ? 'Date indisponible' : date.toLocaleDateString(uiLocale(), { dateStyle: 'long', timeZone: 'UTC' });
};

export const reportTime = value => {
  if (!value) return 'Date indisponible';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? 'Date indisponible' : date.toLocaleString(uiLocale(), { dateStyle: 'medium', timeStyle: 'short', timeZone: 'Europe/Paris' });
};

// Kept for existing imports: the report variant of MarkdownProse.
export const markdownComponents = proseComponents.report;
